/**
 * Focus Mode deep links (BUG-11). A signed-out click on /focus-controllist?framework_id=…
 * or /view/focus?session=… used to land on the Focus home after login because PublicRoutes
 * drops the path. Layout captures the path here before the bounce to Login and
 * handleRedirection restores it once, after the Complete Now deep link but before the
 * role default.
 */
const KEY = 'postLoginRedirect';

const FOCUS_PATH = /^\/(view\/focus|focus-[a-z-]+)$/;

/** True for the Zavvy chat and the Focus pages (with or without a query). */
export const isFocusPath = (pathname) => FOCUS_PATH.test(String(pathname || ''));

export const captureFocusRedirect = (pathname, search = '') => {
  if (!isFocusPath(pathname)) return false;
  if (pathname === '/view/focus' && !search) return false; // the default landing page, nothing to keep
  try { sessionStorage.setItem(KEY, `${pathname}${search || ''}`); } catch { /* storage blocked */ }
  return true;
};

/** Reads and clears the stored Focus path; null when none or when it is not a Focus path. */
export const consumeFocusRedirect = () => {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value === null) return null;
    sessionStorage.removeItem(KEY);
    const [pathname] = value.split(/[?#]/);
    return isFocusPath(pathname) ? value : null;
  } catch { return null; }
};
